<template>
  <div class="format" style="padding: 0 1em;">
    <table cellpadding="0" cellspacing="0" width="95%">
      <tbody>
        <tr>
          <td class="ncut-base-form-text" style="width:5.25em;">類別：</td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-select text="請選擇類別" class="select_text" style="width: 20rem;"
              v-model="fmtType"
              @change="mailType=0; clearData();"
              :disabled="fmtFlag">
              <b-form-select-option
                v-for="item in fmtInfo"
                :key="'t'.concat(item.text1)"
                :value="item.text1">{{item.text2}}
              </b-form-select-option>
            </b-form-select>
          </td>
        </tr>
        <tr>
          <td class="ncut-base-form-text">格式名稱：</td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-select text="請選擇格式" class="select_text" style="width: 20rem;"
              v-model="mailType"
              @change="getMailItem">
              <b-form-select-option
                v-for="item in filterList1"
                :key="'m'.concat(item.id2)"
                :value="item.id2">{{item.text1}}
              </b-form-select-option>
            </b-form-select>
          </td>
        </tr>
        <tr v-show="mailInfo!=null">
          <td colspan="3">
            <div class='well'
              style="display:inline-table; padding: 0.1875em; width: 100%;">
              <table cellpadding="0" cellspacing="0" style="width:99%">
                <tbody>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title" style="width:5.25em; text-align: right;">主旨：</td>
                    <td class="ncut-base-form-ipt" colspan="2" style="padding: 5px 0px 8px 5px;">
                      <b-form-input placeholder="請輸入主旨" style="min-width:20rem;"
                        v-model="mailInfo.subjText"/>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title" style="text-align: right;">內容：</td>
                    <td class="ncut-base-form-ipt" style="padding: 5px 0px 16px 5px;" colspan="2">
                      <b-form-textarea type="textarea" placeholder="請輸入內容"
                        :rows="8"
                        v-model="mailInfo.contText"
                        v-if="!mailInfo.isHTML"/>
                      <ckeditor :config="config"
                        v-model="mailInfo.contText"
                        v-else></ckeditor>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style='text-align: left;'>
      <font style="color:red;">* 紅色為必填欄位</font>
    </div>
    <div v-show="0 < this.mailType">
      <b-button variant="success" @click="save()"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'
import Ckeditor from 'vue-ckeditor2'
export default {
  name: 'format',
  components: {
    Ckeditor
  },
  data () {
    return {
      mailInfo: {
        subjText: '',
        contText: '',
        isHTML: false
      },
      fmtFlag: false,
      mailType: 0,
      fmtType: 0,
      fmtInfo: null,
      fmtList: null,
      config: {
        toolbar: [
          ['Source', '-', 'Preview', '-', 'Templates'],
          ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
          ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
          ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'],
          ['Link', 'Unlink', 'Anchor'],
          ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
          ['Styles', 'Format', 'Font', 'FontSize'],
          ['TextColor', 'BGColor'],
          ['Maximize', 'ShowBlocks'],
          ['About']
        ],
        height: 250,
        width: '97%'
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    filterList1: function () {
      if (!tools.isNull(this.fmtList)) {
        var vm = this
        var shoppingList = this.fmtList
        return shoppingList.filter(function (item) {
          return item.text2 == vm.fmtType
        })
      }
      return []
    }
  },
  methods: {
    // showAlert(type, text) {
    //   const h = this.$createElement
    //   const vNodesMsg = h(
    //       'div',
    //       { class: ['alert-text'] },
    //       [
    //         h('strong', text)
    //       ]
    //   );
    //   this.$bvToast.toast(vNodesMsg, {
    //       title: '請注意',
    //       variant: type,
    //       autoHideDelay: 3000,
    //       solid: true
    //     })
    // },
    clearData () {
      this.mailInfo = {
        subjText: '',
        contText: '',
        isHTML: false
      }
    },
    checkSaveData () {
      let msg = ''

      if (this.mailInfo.subjText.length == 0) {
        msg = '主題'
      } else if (tools.isNull(this.mailInfo.subjText) || (this.mailInfo.subjText.length > 100)) {
        msg = '主題最多 100 個字'
      } else if (this.mailInfo.contText.length == 0) {
        msg = '內容'
      }

      return msg
    },
    save () {
      const msg = this.checkSaveData()
      if (msg.length === 0) {
        var vm = this
        this.$http.put('./WebApi/Setting/SetFormatData', this.mailInfo)
          .then((response) => {
            if (response.data) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功')
            } else {
              tools.showAlert(vm, 'danger', '對不起,存檔失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,驗證失敗')
        return false
      }
    },
    getCodeName: function () {
      return this.$http
        .get('./WebApi/Common/GetCodeNameList/'.concat(this.sysId).concat('/FormatItem/1'))
    },
    getFormatSet: function () {
      return this.$http
        .get('./WebApi/Setting/GetFormatSet/'.concat(this.sysId))
    },
    getMailItem: function () {
      var vm = this
      this.clearData()
      this.$http
        .get('./WebApi/Setting/GetFormatData/'.concat(this.sysId).concat('/').concat(this.mailType))
        .then(function (response) {
          vm.mailInfo = response.data
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗')
        })
    }
  },
  created () {
    // console.log('== FormatView ==');
    var vm = this
    this.$http.all([this.getCodeName(), this.getFormatSet()])
      .then(vm.$http.spread(function (data1, data2) {
        if (!tools.isNull(data1.data)) {
          vm.fmtInfo = data1.data
          if (vm.fmtInfo.length == 1) {
            vm.fmtType = vm.fmtInfo[0].text1
            vm.fmtFlag = true
          }
        }
        if (!tools.isNull(data2.data)) {
          vm.fmtList = data2.data
        }
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select_text {
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.item_text {
  color: #6600ff;
  font-style: italic;
}
</style>
